import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppActions } from '../app.actions';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlansService {

  private _route = inject(ActivatedRoute);
  private _store = inject(Store);

  static planCodeParam = 'planCode';
  static postalCodeParam = 'postalCode';
  static sellerModeParam = 'sellerMode';

  getPlanParamsFromUrl() {

    const url = new URL(window.location.href);
    const code = url.searchParams.get(PlansService.planCodeParam);
    const postalCode = url.searchParams.get(PlansService.postalCodeParam);
    const sellerMode = url.searchParams.get(PlansService.sellerModeParam);

    if (!environment.production && !code && !postalCode) {

      this._store.dispatch(
        new AppActions.Plan.Credentials.Set({ code: 'PSTAR', cep: '15895142' }),
      );
    }

    if (code && postalCode) {
      this._store.dispatch(
        new AppActions.Plan.Credentials.Set({ code, cep: postalCode })
      );
    }

    if (sellerMode === '1' || sellerMode === 'true') {
      this._store.dispatch(new AppActions.SellerMode.Set(true));
    }
  }
}
